import { useEffect } from 'react'
import { useCustomSnackbarError } from './useCustomSnackbarError'
import { registerGlobalErrorHandler } from './globalErrorBridge'

// Must render INSIDE SnackbarProvider (App.jsx) so useCustomSnackbarError works.
export const GlobalQueryErrorBridge = () => {
  const { handleError } = useCustomSnackbarError()

  // handleError is referentially stable (notistack's useSnackbar returns
  // class-bound methods), so this effect registers once per mount.
  useEffect(() => {
    registerGlobalErrorHandler(handleError)
    return () => registerGlobalErrorHandler(null)
  }, [handleError])

  return null
}
